import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierEnterpriseListPage" */
	'pages/supplier/SupplierEnterprise/SupplierEnterpriseListPage'));

export default [{ component, exact: true, path: '/supplier_enterprises' }];